export enum AppointmentTypeEnums {
  MEDICAL_APPOINTMENT = "medical_appointment",
  PERSONAL_APPOINTMENT = "personal_appointment",
  GOVERNMENTAL_APPOINTMENT = "governmental_appointment",
  OUTINGS = "outings",
  VITAL_CHECKS = "vital_checks",
  MEDICATION_EVENT = "medication_event",
  BARTHEL_INDEX = "barthel_index",
  ACCIDENTS_INCIDENTS = "accidents_incidents",
  NURSE_CARE_ASSESSMENT = "nurse_care_assessment",
  RESIDENT_STATE_REPORTING = "resident_state_reporting",
  DAILY_REPORTING = "daily_reporting",
  OTHER = "other",
}
